import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Building } from "lucide-react";
import "./Client.css";

const url = process.env.REACT_APP_BACKEND_URL;

const EditClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    location: "",
    manager_name: "",
    manager_contact: "",
    no_of_capacity: "",
    salary: "",
    note: ""
  });

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const response = await axios.get(`${url}/api/client/${id}`);
        setData(response.data.data);
      } catch (error) {
        toast.error("Failed to load client data");
        navigate("/ViewClient");
      }
    };
    fetchClient();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/client/${id}`, data);

      if (response.data.success) {
        toast.success("Client updated successfully");
        navigate("/ViewClient");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="client-form-container">
        <h2 className="form-title">
          <Building size={20} /> Edit Client
        </h2>

        <div className="header">
          <button onClick={() => navigate('/ViewClient')} className="add-button">
            Back to List
          </button>
        </div>

        <form className="client-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Client Name"
            value={data.name || ""}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="location"
            placeholder="Location"
            value={data.location || ""}
            onChange={handleChange}
          />

          <input
            type="text"
            name="manager_name"
            placeholder="Manager Name"
            value={data.manager_name || ""}
            onChange={handleChange}
          />

          <input
            type="tel"
            name="manager_contact"
            placeholder="Manager Contact"
            value={data.manager_contact || ""}
            onChange={handleChange}
          />

          <input
            type="number"
            name="no_of_capacity"
            placeholder="No of Capacity"
            value={data.no_of_capacity || ""}
            onChange={handleChange}
          />

          <input
            type="number"
            name="salary"
            placeholder="Salary"
            value={data.salary || ""}
            onChange={handleChange}
          />

          <textarea
            name="note"
            placeholder="Note (optional)"
            value={data.note || ""}
            onChange={handleChange}
            rows="3"
          />

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Updating..." : "Update Client"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditClient;